export const CUSTOM_SIP_ADDRESS_VALUE = '__custom__';

export const SIP_ADDRESS_PRESETS: ReadonlyArray<{
  label: string;
  value: string;
}> = [
  { label: 'UAT SIP Proxy', value: '104.197.57.94' },
  { label: 'Azure SIP Proxy', value: '172.24.2.12' },
];

export const SIP_ADDRESS_OPTIONS: OptionType<string>[] = [
  ...SIP_ADDRESS_PRESETS.map(({ label, value }) => ({
    label: `${label} (${value})`,
    value,
  })),
  { label: 'Custom SIP Proxy', value: CUSTOM_SIP_ADDRESS_VALUE },
];

export const PRESET_SIP_ADDRESS_VALUES: ReadonlyArray<string> =
  SIP_ADDRESS_PRESETS.map(({ value }) => value);
